﻿import '@popperjs/core';
import 'bootstrap';
import { Modal } from 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css'

// Custom CSS imports
import '../css/site.css';

const navbar = document.querySelector('.nav-fixed');
const navLi = document.querySelectorAll('nav .container .dropdown-item');
const sections = document.querySelectorAll('section');
//var trackedLinks = document.querySelectorAll('.tracked-link');
const suscribeFormFooter = document.getElementById('form-suscribe-footer');
const suscribeEmailFooter = document.getElementById('suscribe-email-footer');

const [html] = document.getElementsByTagName("html")
const lang = html.getAttribute("lang");

window.addEventListener('scroll', () => {
    var current = "";

    sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (pageYOffset >= sectionTop - 70) {
            current = section.getAttribute("id");
        }
    });

    navLi.forEach((li) => {
        li.classList.remove("active");
        li.ariaCurrent = "false";
        if (li.classList.contains(current)) {
            li.classList.add("active");
            li.ariaCurrent = "true";
        }
    });

    if (window.scrollY > 200) {
        navbar.classList.add('nav-active');
    } else {
        navbar.classList.remove('nav-active');
    }
});

window.addEventListener('load', () => {
    const modalSubscriptionElement = document.getElementById('modal-subscription');
    if (modalSubscriptionElement !== null) {
        const modalSubscription = new Modal(modalSubscriptionElement);
        modalSubscription.show();
    }

    const modalRegistrationElement = document.getElementById('modal-registration');
    if (modalRegistrationElement !== null) {
        const modalRegistration = new Modal(modalRegistrationElement);
        modalRegistration.show();
    }

    const registrationForm = document.getElementById('account-form');
    if (registrationForm !== null) {
        registrationForm.addEventListener('submit', (event) => {
            if (!registrationForm.checkValidity()) {
                event.preventDefault();
            } else {
                let name = document.getElementById('name').value;
                let email = document.getElementById('email').value;
                let phone = document.getElementById('phone').value;
                let investingRange = document.getElementById('investing-range').value;
                let investingTime = document.getElementById('investing-time').value;
                let consent = document.getElementById('consent').checked;

                let properties = {
                    'NOMBRE': name,
                    'TELEFONO': phone,
                    'RANGO_INVERSION': investingRange,
                    'TIEMPO_INVERSION': investingTime,
                    'RECIBE_NOTICIAS': consent
                };

                sendinblue.identify(email, properties);

                properties['email'] = email;
                sendinblue.track('registro_cuenta', properties);
            }
        });
    }

    suscribeFormFooter.addEventListener('submit', (event) => {
        if (!suscribeEmailFooter.validity.valid) {
            event.preventDefault();
        } else {

            let properties = {
                'email': suscribeEmailFooter.value,
                'RECIBE_NOTICIAS': true
            };
            sendinblue.identify(suscribeEmailFooter.value, properties);

            properties = {
                'email': suscribeEmailFooter.value,
                'form': 'footer_form',
                'RECIBE_NOTICIAS': true
            };
            sendinblue.track('suscripcion_newsletter', properties);
        }
    });

    //trackedLinks.forEach((link) => {
    //    var properties = getTrackedLinkProperties(link);

    //    if (properties === null) {
    //        sendinblue.trackLink(link);
    //    }
    //    else {
    //        sendinblue.trackLink(link, properties);
    //    }
    //});

    document.querySelectorAll('a:not(.language-link)').forEach((link) => {
        let notCurrentLang = lang === 'en' ? 'es-MX' : 'en-US';
        let currentLang = lang === 'en' ? 'en-US' : 'es-MX';

        let linkUrl = link.getAttribute('href');

        if (typeof linkUrl !== 'undefined' && linkUrl !== null && linkUrl !== '') {
            if (linkUrl.includes(notCurrentLang)) {
                link.setAttribute('href', linkUrl.replace(notCurrentLang, currentLang));
            }
        }

    });
});

window.getTrackedLinkProperties = (link) => {
    if (link.classList.contains('app-store-link')) {
        return { 'app': 'app_store' };
    }
    if (link.classList.contains('google-play-link')) {
        return { 'app': 'google_play' };
    }
    if (link.classList.contains('facebook-link')) {
        return { 'social': 'facebook' };
    }
    if (link.classList.contains('instagram-link')) {
        return { 'social': 'instagram' };
    }
    if (link.classList.contains('linkedin-link')) {
        return { 'social': 'linkedin' };
    }
    if (link.classList.contains('youtube-link')) {
        return { 'social': 'youtube' };
    }
    return null;
};